"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Vultr = /*#__PURE__*/ _interop_require_default(require("./Vultr"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let VultrPlugin = class VultrPlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return VultrPlugin.storageAdapter;
    }
    async init(config) {
        VultrPlugin.storageAdapter = new _Vultr.default(config);
        await VultrPlugin.storageAdapter.init();
    }
};
const _default = VultrPlugin;
